import styled from 'styled-components'

import { typography } from '../../../assets/styles'

export const Title = styled.h1`
    ${typography.Hero36};
    padding: 0;
    margin-left: 85px;
`

export const Label = styled.h3`
    ${typography.BodyCopy16};
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-right: 85px;
`

export const Titlebar = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin: 40px 0 20px 0;
    padding: 0;
`

export const ReadOnlyFieldset = styled.fieldset`
    border: none;
    padding: 0;
    margin: 0;
`
